import { Address } from "./address";
import { Location } from "./location";
export default {
  address: Address,
  location: Location
};